import React from "react";
import { useAuth } from "../../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  LogOut,
  ChevronRight,
  User,
  Wallet,
  Bell,
  Settings,
} from "lucide-react";
import PageHeader from "../../components/PageHeader";
import ProfileInfoCard from "./components/ProfileInfoCard";
import Button from "../../../../components/ui/Button";

// ✨ Updated link style for a cleaner list view
const ProfileLink = ({ icon: Icon, label, to }) => (
  <a
    href={to}
    className="flex items-center p-4 bg-white hover:bg-slate-50 transition-colors border-b border-slate-100 last:border-b-0"
  >
    <Icon className="w-5 h-5 text-slate-500 mr-4" />
    <span className="flex-grow font-medium text-slate-700">{label}</span>
    <ChevronRight className="w-5 h-5 text-slate-400" />
  </a>
);

const ProfilePage = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    // ✨ Changed background to white for a seamless look
    <div className="flex flex-col h-full bg-white">
      <PageHeader title="Profile" />

      {/* ✨ The content area now scrolls, containing the info and links */}
      <div className="flex-grow overflow-y-auto">
        <ProfileInfoCard user={currentUser} />

        {/* ✨ Removed the extra card wrapper for a cleaner list */}
        <div className="border-y border-slate-200">
          <ProfileLink
            icon={User}
            label="Edit Profile"
            to="/fan/profile/edit"
          />
          <ProfileLink
            icon={Wallet}
            label="Transactions"
            to="/fan/transactions"
          />
          <ProfileLink
            icon={Bell}
            label="Notifications"
            to="/fan/notifications"
          />
          <ProfileLink icon={Settings} label="Settings" to="/fan/settings" />
        </div>
      </div>

      <div className="p-4 border-t border-slate-100">
        <Button
          variant="ghost"
          className="w-full text-red-500 hover:bg-red-50"
          onClick={handleLogout}
        >
          <LogOut className="w-4 h-4 mr-2" />
          Log Out
        </Button>
      </div>
    </div>
  );
};

export default ProfilePage;
